import {Basic} from "./Basic";
import {Display} from "./Display";
import {History} from "./History";

export class Load
{
    static _process(href, fromHistory)
    {
        Load.abortAnimation = false;
        if(Load.animation === undefined)
        {
            Load.animation = false;
        }

        Load.load(href, fromHistory);
    }

    static load(href, fromHistory)
    {
        const currentLocation = document.location.pathname;

        Load.post(href,{f:'load'}).then(r =>
        {
            if(!fromHistory)
            {
                History.push_url(href);
            }

            if(r['page_title'])
            {
                // noinspection JSValidateTypes
                document.title = r['page_title'];
            }

            switch(r['type'])
            {
                case 'Presse':
                case 'Text':
                    Load.scrollY = window.scrollY;
                    const top = document.getElementById('w--content').getBoundingClientRect()['top'];// + Load.scrollY;
                    document.body.classList.add('mod--out');
                    document.getElementById('w--header').style.position = 'fixed';
                    document.getElementById('w--header').style.top = (Load.scrollY * -1).toString() + 'px';
                    document.getElementById('w--content').style.top = top.toString() + 'px';
                    Load.build_articlePages(Load.build_article(currentLocation), r);
                    break;

                case 'Tiles':
                    if(document.getElementById('w--ise-buttons'))
                    {
                        document.getElementById('w--ise-buttons').remove();
                    }

                    if(r['ise-buttons'])
                    {
                        const iseButtons = document.createElement('span');
                        iseButtons.id = 'w--ise-buttons';
                        // noinspection JSCheckFunctionSignatures
                        iseButtons.insertAdjacentHTML('afterbegin', r['ise-buttons']);
                        document.body.appendChild(iseButtons);
                    }

                    window.scrollTo(0,0);
                    const images = [];
                    for(let i=0; i<r['tiles'].length; i++)
                    {
                        if(r['tiles'][i]['img_filename'])
                        {
                            r['tiles'][i]['img_filename'] = Basic.adjust_imagePath(r['tiles'][i]['img_filename'],352);
                            images[images.length] = r['tiles'][i]['img_filename'];
                        }
                    }
                    Load.preload_images(images,() => {Load.build_tiles(r['tiles'])});
                    break;

            }
        }).catch(error => {
            console.error(error);
        });
    }

    static preload_images(images, callback)
    {
        if(images.length === 0)
        {
            callback();
        }
        else
        {
            let imgCounter = images.length;

            // noinspection JSUnresolvedReference
            images.forEach(src =>
            {
                const myImg = new Image;
                myImg.src = src;
                myImg.addEventListener('load',() =>
                {
                    imgCounter--;
                    if(imgCounter === 0)
                    {
                        callback();
                    }
                });
            });
        }
    }

    static build_article(currentLocation)
    {
        const article = document.createElement('article'),
              close = document.createElement('button');

        article.classList.add('w__article');
        if(Display.device === 'desktop')
        {
            article.classList.add('mod--out');
        }
        article.id = 'w--article';

        close.textContent = 'X';
        close.classList.add('w__article--close');
        close.classList.add('w__js-button');
        close.dataset.f = 'article-close';
        close.dataset.history = currentLocation;

        article.appendChild(close);

        document.body.appendChild(article);

        return article;
    }

    static build_articlePages(article, r)
    {
        let i;
        const leftPage = document.createElement('div');
        leftPage.classList.add('w__article--left');

        if(r['img_filename'])
        {
            i = r['images'].length;
            r['images'][i] = Basic.adjust_imagePath(
                r['img_filename'],
                Display.device === 'desktop' ? 512 : Display.x * 16 / 9,
                Display.y);
            const myImage = new Image;
            myImage.alt = '';
            myImage.src = r['images'][i].toString();
            myImage.classList.add(r['img_class']);
            leftPage.appendChild(myImage);
        }

        if(r['img_color'])
        {
            const color = document.createElement('div');
            color.classList.add('w__article--color');
            color.style.backgroundColor = r['img_color'];
            leftPage.appendChild(color);
        }

        if(r['headline_left'])
        {
            const headlineLeft = document.createElement('h2');
            headlineLeft.classList.add('w__article--headline');
            headlineLeft.insertAdjacentHTML('afterbegin', r['headline_left']);
            leftPage.appendChild(headlineLeft);
        }

        if(r['text_left'])
        {
            const textLeft = document.createElement('div');
            textLeft.classList.add('w__article--text');
            textLeft.insertAdjacentHTML('afterbegin', r['text_left']);
            leftPage.appendChild(textLeft);
        }

        if(r['img_copyright'])
        {
            const copyright = document.createElement('span');
            copyright.classList.add('w__article--copyright');
            copyright.insertAdjacentHTML('afterbegin', r['img_copyright']);
            leftPage.appendChild(copyright);
        }

        const rightPage = document.createElement('div');
        rightPage.classList.add('w__article--right');

        if(r['motto'])
        {
            const motto1 = document.createElement('span');
            motto1.classList.add('w__cresc--motto');
            motto1.textContent = 'cresc... ';
            const motto2 = document.createElement('span');
            motto2.classList.add('w__gray-light');
            motto2.textContent = r['motto'];
            motto1.appendChild(motto2);
            rightPage.appendChild(motto1);
        }

        if(r['headline'])
        {
            const headline = document.createElement('h3');
            headline.classList.add('w__article--headline');
            headline.insertAdjacentHTML('afterbegin', r['headline']);
            rightPage.appendChild(headline);
        }

        const text = document.createElement('div');
        text.classList.add('w__article--text');
        text.insertAdjacentHTML('afterbegin', r['text']);
        if(r['downloads'])
        {
            text.insertAdjacentHTML('beforeend', r['downloads']);
        }
        rightPage.appendChild(text);

        article.appendChild(leftPage);
        article.appendChild(rightPage);

        if(r['ise'])
        {
            article.insertAdjacentHTML('beforeend', r['ise']);
        }

        article.offsetHeight;

        Basic.do_afterLoad();

        Load.preload_images(r['images'],() => {
            window.scrollTo(0,0);
            article.classList.remove('mod--out');
        });
    }

    static switch_tile(tile, r)
    {
        if(tile)
        {
            tile.innerHTML = '';
            tile.classList.remove('w__js-button');
            tile.classList.remove('mod--no-image');
            tile.dataset.f = '';
            const tileText = tile.querySelector('.w__tile--text');
            if(tileText)
            {
                tileText.remove();
            }
        }
        else
        {
            tile = document.createElement('a');
            tile.classList.add('w__tile');
            tile.classList.add('mod--out');
            document.getElementById('w--content').appendChild(tile);
        }

        const tileInner = document.createElement('div');
        tileInner.classList.add('w__tile--inner');

        tile.appendChild(tileInner);

        if(r['iseButtons'])
        {
            tile.insertAdjacentHTML('afterbegin', r['iseButtons']);
        }

        if(r['tile_text'])
        {
            const tileText = document.createElement('div');
            tileText.classList.add('w__tile--text');
            tileText.classList.add('mod--hidden');
            tileText.insertAdjacentHTML('afterbegin', r['tile_text']);
            tile.appendChild(tileText);
        }

        if(r['img_filename'])
        {
            const img = new Image;
            img.src = r['img_filename'];
            img.alt = r['img_label'];
            img.width = 352;
            img.height = 198;
            img.classList.add('w__tile--image');
            tileInner.appendChild(img);
        }

        if(r['tile_label'])
        {
            const label = document.createElement('strong');
            label.classList.add('w__tile--title');
            label.insertAdjacentHTML('afterbegin', r['tile_label']);
            tileInner.appendChild(label);
        }

        tileInner.href = r['href'];

        if(r['targetBlank'])
        {
            tileInner.target = '_blank';
        }
        else
        {
            tileInner.classList.add('w__js-button');
            tileInner.dataset.f = 'load';
        }

        r['classes'].forEach(addClass => {
            tileInner.classList.add(addClass);
        });

        tile.style.transition = 'none';
        tile.style.transform = 'perspective(1000px) rotateX(90deg) scale(1,-1)';
        tile.classList.remove('mod--out');
        tile.offsetHeight;
        tile.style.transition = '';
        tile.style.transform = '';

        tile.classList.add('mod--in');
    }

    static build_tiles(newTiles)
    {
        const myTimeout = Load.reduce_tiles();
        let currentTiles;

        if(Load.animation === true)
        {
            Load.abortAnimation = true;
            setTimeout(() => {
                currentTiles = document.getElementById('w--content').querySelectorAll('.w__tile:not(:first-child)');
                for(let i=0 ; i<currentTiles.length; i++)
                {
                    currentTiles[i].remove();
                }
                Load.abortAnimation = false;
                Load.start_tileAnimation(newTiles, {}, newTiles.length, myTimeout);
            }, Basic.transitionTimer);
        }
        else
        {
            currentTiles = document.getElementById('w--content').querySelectorAll('.w__tile:not(:first-child)');
            const max = currentTiles.length > newTiles.length ? currentTiles.length : newTiles.length;
            Load.start_tileAnimation(newTiles, currentTiles, max, myTimeout);
        }
    }

    static start_tileAnimation(newTiles, currentTiles, max, myTimeout)
    {
        Load.animation = true;
        setTimeout(() =>
        {
            if(Load.abortAnimation === false)
            {
                Load.animate_tile(currentTiles, newTiles, 0, max, 0);
            }
        }, myTimeout);
    }

    static animate_tile(currentTiles, newTiles, i, max, myTimeout)
    {
        if(i < max)
        {
            setTimeout(() =>
            {
                if(Load.abortAnimation === false)
                {
                    if(currentTiles[i])
                    {
                        currentTiles[i].classList.add('mod--out');
                    }

                    setTimeout(() =>
                    {
                        if(newTiles[i])
                        {
                            Load.switch_tile(currentTiles[i], newTiles[i]);
                        }
                        else if(currentTiles[i])
                        {
                            currentTiles[i].classList.add('w__none');
                        }

                        if(i === max - 1)
                        {
                            setTimeout(() =>
                            {
                                Load.cleanup_tiles();
                                Load.expand_tiles();
                                Load.animation = false;
                            }, Basic.transitionTimer);
                        }

                    }, Basic.transitionTimer);

                    Load.animate_tile(currentTiles, newTiles,i+1, max,100);
                }
            }, myTimeout);
        }
    }

    static cleanup_tiles()
    {
        const tiles = document.getElementById('w--content').querySelectorAll('.w__tile:not(:first-child)');
        for(let i=0; i<tiles.length; i++)
        {
            if(tiles[i].classList.contains('w__none'))
            {
                tiles[i].remove();
            }
            else
            {
                tiles[i].style.transition = 'none';
                tiles[i].classList.remove('mod--in');
                tiles[i].offsetHeight;
                tiles[i].style.transition = '';
            }
        }
    }

    static expand_tiles()
    {
        if(document.getElementById('w--content').querySelector('.w__tile--text'))
        {
            const tileTexts = document.getElementById('w--content').querySelectorAll('.w__tile--text');
            for(let i=0; i<tileTexts.length; i++)
            {
                tileTexts[i].dataset.height = tileTexts[i].getBoundingClientRect()['height'].toString() + 'px';
                tileTexts[i].classList.add('mod--reduced');
                tileTexts[i].classList.remove('mod--hidden');
                tileTexts[i].offsetHeight;
            }
            for(let i=0; i<tileTexts.length; i++)
            {
                tileTexts[i].style.height = tileTexts[i].dataset.height;
            }
        }
    }

    static reduce_tiles()
    {
        let myTimeout = 0;

        if(document.getElementById('w--content').querySelector('.w__tile--text'))
        {
            const tileTexts = document.getElementById('w--content').querySelectorAll('.w__tile--text');
            for(let i=0; i<tileTexts.length; i++)
            {
                tileTexts[i].style.height = tileTexts[i].getBoundingClientRect()['height'].toString() + 'px';
                tileTexts[i].classList.add('mod--reduced');
                tileTexts[i].offsetHeight;
            }
            for(let i=0; i<tileTexts.length; i++)
            {
                tileTexts[i].style.height = '0';
            }

            myTimeout = Basic.transitionTimer;
        }

        return myTimeout;
    }

    static close(el, fromHistory)
    {
        const article = document.getElementById('w--article');
        if(article)
        {
            if(el && !fromHistory)
            {
                History.push_url(el.dataset.history);
            }

            document.title = document.title.split(' / ').slice(1).join(' / ');
            document.documentElement.scrollTo(0,0);

            article.classList.add('mod--out');
            document.getElementById('w--header').removeAttribute('style');
            document.body.classList.remove('mod--out');

            if(Display.device === 'desktop')
            {
                setTimeout(() =>
                {
                    article.remove();
                    document.documentElement.scrollTo(0, (Load.scrollY ? Load.scrollY : 0));
                }, Basic.transitionTimer * 2);
            }
            else
            {
                article.remove();
                document.documentElement.scrollTo(0, (Load.scrollY ? Load.scrollY : 0));
            }
        }
    }

    static post(href, myData)
    {
        document.documentElement.classList.add('w__waiting');
        myData.url = href;
        myData.time = new Date().getTime();

        return new Promise(function(resolve, reject)
        {
            const myRequest = new XMLHttpRequest();
            myRequest.timeout = 10000;
            myRequest.onreadystatechange = function()
            {
                if(myRequest.readyState === 4)
                {
                    document.documentElement.classList.remove('w__waiting');
                    if(myRequest.status === 200 && myRequest.response)
                    {
                        if(myRequest.response['status'] === 'OK')
                        {
                            resolve(myRequest.response);
                        }
                        else
                        {
                            reject(myRequest.response);
                        }
                    }
                    else
                    {
                        reject('Empty response. Status: ' + myRequest.status);
                    }
                }
            };

            myRequest.ontimeout = function()
            {
                document.documentElement.classList.remove('w__waiting');
                reject('Request timed out. Network problems?');
            };

            myRequest.open("POST",Basic.base + 'index.php');
            myRequest.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=utf-8");
            myRequest.setRequestHeader("Accept","application/json");
            myRequest.responseType = 'json';
            myRequest.send('json=' + encodeURIComponent(JSON.stringify(myData)));
        });
    }
}

